import { __read, __values } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { buildListState, listStateSystem } from './listStateSystem';
import { propsReadySystem } from './propsReadySystem';
import { sizeSystem } from './sizeSystem';
export var initialItemCountSystem = u.system(function (_a) {
    var _b = __read(_a, 3), _c = _b[0], sizes = _c.sizes, firstItemIndex = _c.firstItemIndex, data = _c.data, listState = _b[1].listState, didMount = _b[2].didMount;
    var initialItemCount = u.statefulStream(0);
    u.connect(u.pipe(didMount, u.withLatestFrom(initialItemCount), u.filter(function (_a) {
        var _b = __read(_a, 2), count = _b[1];
        return count !== 0;
    }), u.withLatestFrom(sizes, firstItemIndex, data), u.map(function (_a) {
        var e_1, _b;
        var _c = __read(_a, 4), _d = __read(_c[0], 2), count = _d[1], sizes = _c[1], firstItemIndex = _c[2], _e = _c[3], data = _e === void 0 ? [] : _e;
        var includedGroupsCount = 0;
        if (sizes.groupIndices.length > 0) {
            try {
                for (var _f = __values(sizes.groupIndices), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var index = _g.value;
                    if (index - includedGroupsCount >= count) {
                        break;
                    }
                    includedGroupsCount++;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var adjustedCount = count + includedGroupsCount;
        var items = Array.from({ length: adjustedCount }).map(function (_, index) { return ({ index: index, size: 0, offset: 0, data: data[index] }); });
        return buildListState(items, [], adjustedCount, sizes, firstItemIndex);
    })), listState);
    return { initialItemCount: initialItemCount };
}, u.tup(sizeSystem, listStateSystem, propsReadySystem), { singleton: true });
